import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FeedbackFormData } from '../../_models/feedbackFormData';
import { AuthService } from '../../_services/auth.service';
import { SharedService } from '../../_services/shared.service';
import { TranslatedToastService } from '../../_services/translated-toast.service';
import { GraphService } from '../../_services/graph.service';
import { FeedbackReqDto } from '../../_dtos/feedbackReqDto';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-feedback-form',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatError,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './feedback-form.component.html',
  standalone: true,
  styleUrl: './feedback-form.component.css',
})
export class FeedbackFormComponent implements OnInit {
  public FeedbackForm!: FormGroup;
  private userPrincipalName!: string;

  constructor(
    private authService: AuthService,
    public toastr: TranslatedToastService,
    private graphService: GraphService,
    private sharedService: SharedService,
  ) {}

  ngOnInit() {
    this.userPrincipalName = this.authService.getUsername();
    this.initializeForm();
  }

  async onSubmit() {
    if (this.FeedbackForm.valid) {
      const formValues = this.FeedbackForm.getRawValue();
      const feedbackRequestDto: FeedbackReqDto = {
        Feedback: formValues.feedback,
        BernieRDMVersion: environment.version,
      };
      this.sharedService.closeModal();
      this.graphService.createSPItem(feedbackRequestDto).subscribe({
        next: async () => {
          await this.toastr.show(
            'success',
            'TOASTS.FEEDBACK.SUBMIT_MESSAGE',
            'TOASTS.FEEDBACK.SUBMIT_TITLE',
          );
        },
      });
    }
  }

  get feedback() {
    return this.FeedbackForm.get('feedback');
  }

  get errorMessage() {
    if (this.feedback?.hasError('required')) return 'Feedback is required';
    else return '';
  }

  private initializeForm() {
    this.FeedbackForm = new FormGroup<FeedbackFormData>({
      sender: new FormControl(
        { value: this.authService.getDisplayName(), disabled: true },
        { nonNullable: true },
      ),
      feedback: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });
  }
}
